import { render, staticRenderFns } from "./QuestionBuilder.vue?vue&type=template&id=33887010&scoped=true&"
import script from "./QuestionBuilder.vue?vue&type=script&lang=ts&"
export * from "./QuestionBuilder.vue?vue&type=script&lang=ts&"
import style1 from "./QuestionBuilder.vue?vue&type=style&index=1&id=33887010&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33887010",
  null
  
)

export default component.exports